import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import EnhancedBriefingModal from './EnhancedBriefingModal';
import useDataFetch from '../hooks/useDataFetch';
import axios from 'axios';

const BriefingPage = () => {
  const { summaryId } = useParams();
  const navigate = useNavigate();
  const [authUser, setAuthUser] = useState(null);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const res = await axios.get('/api/auth/me');
        setAuthUser(res.data || null);
      } catch (error) {
        setAuthUser(null);
      }
    };
    checkAuth();
  }, []);

  const fetchBriefing = async () => {
    const response = await fetch(`/api/briefing/${summaryId}`);
    if (!response.ok) {
      throw new Error('Failed to fetch briefing');
    }
    return response.json();
  };

  const { data: briefingData, loading, error } = useDataFetch(fetchBriefing, [summaryId]);

  const handleClose = () => {
    navigate('/');
  };

  return (
    <EnhancedBriefingModal
      show={true}
      briefingData={briefingData}
      summaryId={summaryId}
      onClose={handleClose}
      isPublic={true}
      authUser={authUser}
    />
  );
};

export default BriefingPage;